import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchAppliedInternshipList = createAsyncThunk(
    "fetchAppliedInternshipList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/internship/fetch-applied-internship?page=${body.page}&search=${body.search}&status=${body.status}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const AppliedInternshipSlice = createSlice({
    name: "AppliedInternshipSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAppliedInternshipList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchAppliedInternshipList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(fetchAppliedInternshipList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default AppliedInternshipSlice.reducer;
